// Variables de mouvement partagées par toute l'application.
// Une seule courbe, deux durées.
export const EASE = [0.22, 1, 0.36, 1];
export const DUR_TOUCH = 0.18; // 180ms — tout ce qui répond à un doigt
export const DUR_SCREEN = 0.42; // 420ms — changement d'écran
export const DUR_REDUCED = 0.12; // 120ms — prefers-reduced-motion
export const STAGGER = 0.05; // 50ms entre titre / sous-titre / options

export const haptic = () => {
    if (typeof navigator !== "undefined" && navigator.vibrate) {
        try { navigator.vibrate(10); } catch (e) { /* noop */ }
    }
};
